import { render, staticRenderFns } from "./PromocodeCard.vue?vue&type=template&id=6d06ec02"
import script from "./PromocodeCard.vue?vue&type=script&lang=js"
export * from "./PromocodeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports